import React, {Component} from 'react'

import chrome from '../img/logos/chrome.png'
import firefox from '../img/logos/firefox.png'
import opera from '../img/logos/opera.png'

class Incompatible extends Component {
	constructor( props ) {
		super()
		this.state = {
			texts: {},
			lang: props.lang
		}
	}
	
	updateLang( lang, texts ) {
		this.setState( {
			lang: lang,
			texts:texts
		} )
	}

	render() {
		let tx = this.state.texts || {}
		
		return (
			<div className='incompatible_content'>
				<h1>{ tx.oldBrowser1 }</h1>
				<h2>{ tx.oldBrowser2 }</h2>
				<h3>{ tx.oldBrowser3 }</h3>
				<ul className='incompatible_list'>
					<li>
						<span className="ico">
							<img src={firefox} alt="firefox"/>
						</span>
						<a href="https://www.mozilla.org/">Mozilla Firefox</a>
					</li>
					<li>
						<span className="ico">
							<img src={chrome} alt="chrome"/>
						</span>
						<a href="https://www.google.ru/chrome/browser/desktop/">Google Chrome</a>
					</li>
					<li>
						<span className="ico">
							<img src={opera} alt="opera"/>
						</span>
						<a href="http://www.opera.com/">Opera</a>
					</li>
				</ul>
			</div>
		)
	}
}

export default Incompatible


// WEBPACK FOOTER //
// ./src/browserCheck/incompatible.jsx